import React from "react";
import classNames from "classnames";

import { BaseProps } from "@src/types/BaseProps.types";

import "./Button.scss";

export interface ButtonProps extends BaseProps<HTMLButtonElement> {
  type?: "button" | "submit" | "reset";
  variant?: "primary" | "secondary";
  children: React.ReactNode | React.ReactElement;
  loading?: boolean;
  uppercase?: boolean;
  fullWidth?: boolean;
  disabled?: boolean;
  onClick?(): void;
  onBlur?(): void;
  onMouseEnter?(): void;
  onMouseLeave?(): void;
}

const Button = ({
  type = "button",
  variant = "primary",
  children,
  disabled = false,
  loading = false,
  uppercase = true,
  fullWidth = false,
  className = "",
  onClick = () => {},
  onBlur = () => {},
  onMouseEnter = () => {},
  onMouseLeave = () => {},
  ...props
}: ButtonProps) => {
  const classes = classNames(
    `button button-${variant}`,
    {
      uppercase: uppercase,
      "full-width": fullWidth
    },
    className
  );

  return (
    <button
      type={type}
      disabled={disabled || loading}
      className={classes}
      onClick={onClick}
      onBlur={onBlur}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
